export const AppDependencyTypes = {
  AppPresenter: Symbol.for('AppPresenter'),
  AuthenticationRequiredNavigationListener: Symbol.for('AuthenticationRequiredNavigationListener'),
};
